import { render } from "./UserSearchView.vue?vue&type=template&id=897cbd66&scoped=true&lang=pug"
import script from "./UserSearchView.vue?vue&type=script&lang=js"
export * from "./UserSearchView.vue?vue&type=script&lang=js"

import "./UserSearchView.vue?vue&type=style&index=0&id=897cbd66&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-897cbd66"]])

export default __exports__